import React, { useEffect, useState } from "react"
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material"
import Servo from "../../services/servo"
import Vista from "../../components/Vista"
import moment from "moment"
import dateComponent from "../../components/dateComponent"
import { LoadingButton } from "@mui/lab"

const EficienciaMecanicos = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [fechaInicio, setFechaInicio] = useState(dateComponent.getFirstDayOfMonth())
  const [fechaFinal, setFechaFinal] = useState(dateComponent.getActualDay())

  const getData = async () => {
    setLoading(true)
    let res = await Servo.get(`reportes/reporte-eficiencia?fechaInicio=${fechaInicio}&fechaFinal=${fechaFinal}`)
    if (res?.cuerpo?.detalle?.datos && Array.isArray(res.cuerpo.detalle.datos)) {
      setData(res.cuerpo.detalle.datos)
    } else {
      setData([])
    }
    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, [])

  const porMecanico = {}
  if (Array.isArray(data)) {
    data.forEach((item) => {
      const key = item.mecanicoCargo || "No Asignado"
      if (!porMecanico[key]) {
        porMecanico[key] = {
          mecanico: key,
          tareas: 0,
          eficienciaPromedio: 0,
          totalEficiencia: 0,
          horasTabulador: 0,
          horasReales: 0
        }
      }
      porMecanico[key].tareas += 1

      if (item.eficiencia_lograda) {
        porMecanico[key].totalEficiencia += parseFloat(item.eficiencia_lograda) || 0
        const horasReal = (new Date(item.fecha_fin) - new Date(item.fecha_inicio)) / 1000 - (item.segundos_pausa || 0)
        if (!isNaN(horasReal)) {
          porMecanico[key].horasReales += (horasReal / 3600)
        }
      }
      porMecanico[key].horasTabulador += parseFloat(item.duracionTabulador || 0)
    })
  }

  // Calcular Promedios Reales
  const resumen = Object.values(porMecanico).map(mec => {
    mec.eficienciaPromedio = mec.horasReales > 0 ? (mec.horasTabulador / mec.horasReales) * 100 : 0
    return mec
  })

  return (
    <Vista>
      <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "20px" }}>

        <Paper elevation={3} style={{ padding: "20px" }}>
          <h3>Filtros</h3>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                type="date"
                label="Fecha Inicio"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                type="date"
                label="Fecha Fin"
                value={fechaFinal}
                onChange={(e) => setFechaFinal(e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ display: "flex", alignItems: "flex-end" }}>
              <LoadingButton loading={loading} onClick={getData} variant="contained" color="primary" fullWidth>
                Filtrar
              </LoadingButton>
            </Grid>
          </Grid>
        </Paper>

        <Paper elevation={3} style={{ padding: "20px" }}>
          <h2>Reporte de Eficiencia por Mecánico</h2>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#157CC1" }}>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Mecánico</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Tareas Terminadas</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Horas Tabulador</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Horas Reales Trabajadas</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>Eficiencia Promedio</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {resumen.length > 0 ? resumen.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{row.mecanico}</TableCell>
                    <TableCell>{row.tareas}</TableCell>
                    <TableCell>{row.horasTabulador.toFixed(2)}h</TableCell>
                    <TableCell>{row.horasReales.toFixed(2)}h</TableCell>
                    <TableCell sx={{ color: row.eficienciaPromedio >= 100 ? "green" : (row.eficienciaPromedio > 85 ? "orange" : "red"), fontWeight: "bold" }}>
                      {row.eficienciaPromedio.toFixed(2)}%
                    </TableCell>
                  </TableRow>
                )) : (
                  <TableRow><TableCell colSpan={5} sx={{ textAlign: "center" }}>No hay datos en este rango</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

      </div>
    </Vista>
  )
}

export default EficienciaMecanicos
